import { type IParamsOrganizationQuietHours } from 'entities/Organization/api/types'
import { QuietHours } from '../model'
import { isInQuietHoursTimeframe } from './quietHours'
import { CallDuringQuietHoursModal } from '../ui/CallDuringQuietHoursModal'

export type IShowCallDuringQuietHoursModalIfNeededParams = {
  timezone: string
  contactName: string
  organizationQuietHoursSettings: IParamsOrganizationQuietHours | null | undefined
  onConfirm: () => void | Promise<void>
}

export const showCallDuringQuietHoursModalIfNeeded = (
  params: IShowCallDuringQuietHoursModalIfNeededParams
): boolean => {
  const { timezone, contactName, organizationQuietHoursSettings, onConfirm } = params

  const quietHours = new QuietHours(organizationQuietHoursSettings)
  const isShowQuietHoursModal =
    quietHours.isQuietHoursEnabled &&
    isInQuietHoursTimeframe(
      timezone,
      quietHours.quietHoursAllowedTimeFrom,
      quietHours.quietHoursAllowedTimeTo
    )

  if (!isShowQuietHoursModal) return false

  CallDuringQuietHoursModal({
    timezone,
    contactName,
    quietHoursAllowedTimeFrom: quietHours.quietHoursAllowedTimeFrom,
    quietHoursAllowedTimeTo: quietHours.quietHoursAllowedTimeTo,
    isQuietHoursBlockOnWeekend: quietHours.isQuietHoursBlockOnWeekend,
    onConfirm,
  })

  return true
}
